import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getSalesChannels } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

export const FormSalesChannels = () => {

    const { t } = useTranslation('booking');

    const salesChannelsQuery = useQuery({
        queryKey: [ReactQueryKey.SalesChannels],
        queryFn: getSalesChannels,
        enabled: false
    });

    const handleOnOpen = () => {
        if(salesChannelsQuery.data == undefined) 
            salesChannelsQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="salesChannels"
            label={t('label.salesChannels')}
            options={salesChannelsQuery.data || []}
            loading={salesChannelsQuery.isLoading}
            multiple
            isOptionEqualToValue={(option, value) => option.code === value.code}
            onOpen={handleOnOpen}
        />
    );
};

export default FormSalesChannels;